$(document).ready(function(){
    $("#stickyMenu").not(".js-menuholder").sticky({topSpacing:0});
});
